module.exports = __webpack_public_path__ + "static/media/rahma.8dee290d.webp";